export default {
    title: "Stores",
    filters: {
        title: 'Stores filter',
        resetAllButton: 'Reset all',
        mobileButton: 'Filters'
    },
    headerActions: {
        sortFilters: {
            newest: 'Newest',
            popularity: 'Most Popular'
        },
        search: 'Search',
        stores: 'stores'
    },
}
